import { add, isAfter, isWithinInterval } from 'date-fns';
import { IScheduleArrays } from '../model/ScheduleHub';

export type ScheduleStartInfo = {
  // Status of the schedule start:
  // offWeek: is when the schedule start is after the first content.
  // emptyWeek: is when the schedule start is within the first week, but the first content only in the next week.
  // onTime: is when the normal flow of the schedule.
  status: 'offWeek' | 'emptyWeek' | 'onTime';
  // Date that will be shown if the next week will start only in the next monday
  fallbackDate?: Date;
};

export const getScheduleStartInfo = (week: IScheduleArrays[], dataFirstContent: Date | null): ScheduleStartInfo => {
  if (!week[0]?.start || !week[0]?.end) {
    return { status: 'onTime' };
  }

  //if week is not the first, return onTime
  if(isAfter(new Date(), new Date(week[0].end))) {
    return { status: 'onTime' };
  }

  const isFirstContentWithinFirstWeek = dataFirstContent && isWithinInterval(add(new Date(dataFirstContent), { hours: 3 }), {
    start: new Date(week[0].start),
    end: new Date(week[0].end),
  });

  const today = new Date();

  const isWithinFirstWeek = isWithinInterval(today, {
    start: new Date(week[0].start),
    end: new Date(week[0].end),
  });

  if(isFirstContentWithinFirstWeek && !isWithinFirstWeek) {
    return { status: 'offWeek', fallbackDate: add(new Date(dataFirstContent || ''), { hours: 3 }) };
  }

  if(!isFirstContentWithinFirstWeek && isWithinFirstWeek) {
    return { status: 'emptyWeek', fallbackDate: add(new Date(dataFirstContent || ''), { hours: 3 }) };
  }

  return { status: 'onTime' };
}
